import { createRoot } from "react-dom/client";
import App from "./App";
// Fonts are self-hosted (bundled) so no render-blocking request to Google Fonts is needed.
import "./fonts.css";
import "@fontsource/source-sans-3/latin-400.css";
import "@fontsource/source-sans-3/latin-600.css";
import "@fontsource/source-sans-3/latin-700.css";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
